/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as cameraAccessV1 from "./keyapis_vc_camera_access_v1.pb"

/**
 * События камер
 */

/**
 * Задача на создание доступа к камере.
 * Очередь key.vc.create_camera_access
 */
export type CreateCameraAccessTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификаторы камер в vcfront.
   * # Тип: Guid
   */
  externalIds: string[]
  /**
   * Тип субъекта доступа
   */
  cameraAccessAccessorType: cameraAccessV1.CameraAccessAccessorTypeRequestEnum
  /**
   * Идентификатор субъекта доступа.
   * # Диапазон: 1..36
   */
  accessorId: string
  /**
   * Идентификатор компании в vcfront.
   * # Диапазон: 1..2147483647
   */
  vcCompanyId: number
}
/**
 * Задача на создание доступа к камере.
 * Очередь key.vc.create_camera_access
 */
export type CreateCameraAccessTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификаторы камер в vcfront.
   * # Тип: Guid
   */
  externalIds: string[]
  /**
   * Тип субъекта доступа
   */
  cameraAccessAccessorType: cameraAccessV1.CameraAccessAccessorTypeResponseEnum
  /**
   * Идентификатор субъекта доступа.
   * # Диапазон: 1..36
   */
  accessorId: string
  /**
   * Идентификатор компании в vcfront.
   * # Диапазон: 1..2147483647
   */
  vcCompanyId: number
}
/**
 * Задача на удаление доступа к камере.
 * Очередь key.vc.delete_camera_access
 */
export type DeleteCameraAccessTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификаторы камер в vcfront.
   * # Тип: Guid
   */
  externalIds: string[]
  /**
   * Тип субъекта доступа
   */
  cameraAccessAccessorType: cameraAccessV1.CameraAccessAccessorTypeRequestEnum
  /**
   * Идентификатор субъекта доступа.
   * # Диапазон: 1..36
   */
  accessorId: string
  /**
   * Идентификатор компании в vcfront.
   * # Диапазон: 1..2147483647
   */
  vcCompanyId: number
}
/**
 * Задача на удаление доступа к камере.
 * Очередь key.vc.delete_camera_access
 */
export type DeleteCameraAccessTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификаторы камер в vcfront.
   * # Тип: Guid
   */
  externalIds: string[]
  /**
   * Тип субъекта доступа
   */
  cameraAccessAccessorType: cameraAccessV1.CameraAccessAccessorTypeResponseEnum
  /**
   * Идентификатор субъекта доступа.
   * # Диапазон: 1..36
   */
  accessorId: string
  /**
   * Идентификатор компании в vcfront.
   * # Диапазон: 1..2147483647
   */
  vcCompanyId: number
}
/**
 * Задача на отвязку камеры от точек доступа.
 * Отправляется при удалении камеры.
 * Очередь key.vc.detach_camera_from_access_points
 */
export type DetachCameraFromAccessPointTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор камер в vcfront.
   * # Тип: Guid
   */
  externalId: string
}
/**
 * Задача на отвязку камеры от точек доступа.
 * Отправляется при удалении камеры.
 * Очередь key.vc.detach_camera_from_access_points
 */
export type DetachCameraFromAccessPointTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор камер в vcfront.
   * # Тип: Guid
   */
  externalId: string
}
/**
 * Задача на отвязку камеры от устройств.
 * Отправляется при удалении камеры.
 * Очередь key.vc.detach_camera_from_devices
 */
export type DetachCameraFromDeviceTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор камер в vcfront.
   * # Тип: Guid
   */
  externalId: string
}
/**
 * Задача на отвязку камеры от устройств.
 * Отправляется при удалении камеры.
 * Очередь key.vc.detach_camera_from_devices
 */
export type DetachCameraFromDeviceTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор камер в vcfront.
   * # Тип: Guid
   */
  externalId: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Задача на создание доступа к камере.
   * Очередь key.vc.create_camera_access
   */
  "CreateCameraAccessTask": {
    "kind": "class",
    "text": "Задача на создание доступа к камере.\nОчередь key.vc.create_camera_access",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификаторы камер в vcfront.
       * # Тип: Guid
       */
      "externalIds": {
        "type": "string",
        "text": "Идентификаторы камер в vcfront.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип субъекта доступа
       */
      "cameraAccessAccessorType": {
        "type": "CameraAccess.AccessorType",
        "text": "Тип субъекта доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор субъекта доступа.
       * # Диапазон: 1..36
       */
      "accessorId": {
        "type": "string",
        "text": "Идентификатор субъекта доступа.\n# Диапазон: 1..36",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 36,
            "message": "Значение не входит в допустимый диапазон. Максимум: 36"
          },
        }
      },
      /**
       * Идентификатор компании в vcfront.
       * # Диапазон: 1..2147483647
       */
      "vcCompanyId": {
        "type": "int32",
        "text": "Идентификатор компании в vcfront.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Задача на удаление доступа к камере.
   * Очередь key.vc.delete_camera_access
   */
  "DeleteCameraAccessTask": {
    "kind": "class",
    "text": "Задача на удаление доступа к камере.\nОчередь key.vc.delete_camera_access",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификаторы камер в vcfront.
       * # Тип: Guid
       */
      "externalIds": {
        "type": "string",
        "text": "Идентификаторы камер в vcfront.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип субъекта доступа
       */
      "cameraAccessAccessorType": {
        "type": "CameraAccess.AccessorType",
        "text": "Тип субъекта доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор субъекта доступа.
       * # Диапазон: 1..36
       */
      "accessorId": {
        "type": "string",
        "text": "Идентификатор субъекта доступа.\n# Диапазон: 1..36",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 36,
            "message": "Значение не входит в допустимый диапазон. Максимум: 36"
          },
        }
      },
      /**
       * Идентификатор компании в vcfront.
       * # Диапазон: 1..2147483647
       */
      "vcCompanyId": {
        "type": "int32",
        "text": "Идентификатор компании в vcfront.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Задача на отвязку камеры от точек доступа.
   * Отправляется при удалении камеры.
   * Очередь key.vc.detach_camera_from_access_points
   */
  "DetachCameraFromAccessPointTask": {
    "kind": "class",
    "text": "Задача на отвязку камеры от точек доступа.\nОтправляется при удалении камеры.\nОчередь key.vc.detach_camera_from_access_points",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор камер в vcfront.
       * # Тип: Guid
       */
      "externalId": {
        "type": "string",
        "text": "Идентификатор камер в vcfront.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на отвязку камеры от устройств.
   * Отправляется при удалении камеры.
   * Очередь key.vc.detach_camera_from_devices
   */
  "DetachCameraFromDeviceTask": {
    "kind": "class",
    "text": "Задача на отвязку камеры от устройств.\nОтправляется при удалении камеры.\nОчередь key.vc.detach_camera_from_devices",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор камер в vcfront.
       * # Тип: Guid
       */
      "externalId": {
        "type": "string",
        "text": "Идентификатор камер в vcfront.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}